import { jwtDecode } from "./jwt-decode";

export function isTokenExpired(token: string) {
    const jwt = jwtDecode(token);
    var exp = (jwt.exp as number) * 1000;
    var now = new Date().getTime();
    if (now >= exp) {
        return true;
    }
    return false;

}